export enum CloudProviders {
  AZURE = 'azure',
  GCP = 'gcp',
  AWS = 'aws'
}
